function upDecorateChampCheckoutUrl(url) {
  if (
    url &&
    window.UltimaPeakTracking &&
    typeof window.UltimaPeakTracking.decorateChampUrl === 'function'
  ) {
    return window.UltimaPeakTracking.decorateChampUrl(url);
  }

  return url;
}

class PumpkinPdpBundlePickerElement extends HTMLElement {
  connectedCallback() {
    this.pumpkinCards = Array.from(this.querySelectorAll('.pumpkin_pdp_bundle_picker__card-wrap'));
    this.pumpkinMobileCta = this.querySelector('.pumpkin_pdp_bundle_picker__mobile-cta');
    this.pumpkinMobileCtaLabel = this.querySelector('.pumpkin_pdp_bundle_picker__mobile-cta-label');
    this.pumpkinMobileCtaPrice = this.querySelector('.pumpkin_pdp_bundle_picker__mobile-cta-price');
    this.pumpkinMobileCtaCompareSel = this.querySelector('.pumpkin_pdp_bundle_picker__mobile-cta-compare s');

    if (!this.pumpkinCards.length) return;

    this.pumpkinCards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('.pumpkin_pdp_bundle_picker__card-cta')) return;
        this.selectPumpkinCard(card);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectPumpkinCard(card);
        }
      });
    });

    const pumpkinDefaultCard =
      this.pumpkinCards.find((card) => card.hasAttribute('data-featured')) ?? this.pumpkinCards[0];

    this.selectPumpkinCard(pumpkinDefaultCard);
  }

  selectPumpkinCard(selected) {
    this.pumpkinCards.forEach((card) => {
      card.classList.remove('is-selected');
      card.setAttribute('aria-checked', 'false');
    });

    selected.classList.add('is-selected');
    selected.setAttribute('aria-checked', 'true');

    if (this.pumpkinMobileCta) this.updatePumpkinMobileCta(selected);
  }

  updatePumpkinMobileCta(card) {
    const {
      checkoutUrl = '#',
      salePrice = '',
      comparePrice = '',
      ctaText = 'Add to Cart'
    } = card.dataset;

    this.pumpkinMobileCta.href = upDecorateChampCheckoutUrl(checkoutUrl);
    this.pumpkinMobileCta.setAttribute('aria-label', `${ctaText} — ${salePrice}`);

    if (this.pumpkinMobileCtaLabel) this.pumpkinMobileCtaLabel.textContent = ctaText;
    if (this.pumpkinMobileCtaPrice) this.pumpkinMobileCtaPrice.textContent = salePrice;
    if (this.pumpkinMobileCtaCompareSel) this.pumpkinMobileCtaCompareSel.textContent = comparePrice;
  }
}

if (!customElements.get('pumpkin-pdp-bundle-picker')) {
  customElements.define('pumpkin-pdp-bundle-picker', PumpkinPdpBundlePickerElement);
}